/*
 *
 *  GOOGLE MAPS FUNCTION
 *  contains general google maps function, to create a google maps of the given address data
 *  can be used on different places throughout the website
 *
 */

// Create map google maps
function CreateGoogleMaps(arrAddress, strDivId) {
    // Google maps
    // Get latittude and longitude to determine the position
    var objLatLng = new google.maps.LatLng(arrAddress['latittude'], arrAddress['longitude']);
    // Map options
    var arrOptions = {
        center: objLatLng,
        draggable: false,
        disableDefaultUI: true,
        navigationControl: true,
        mapTypeControl: true,
        mapTypeControlOptions: {style: google.maps.MapTypeControlStyle.DROPDOWN_MENU},
        mapTypeId: google.maps.MapTypeId.ROADMAP,
        scaleControl: false,
        scrollwheel: false,
        zoomControl: true,
        zoom: 12,
    };

    // Generate map object
    var objGoogleMaps = new google.maps.Map(document.getElementById(strDivId), arrOptions);

    return objGoogleMaps;
}

// Create marker in google maps
function CreateGoogleMapsMarker(objGoogleMaps, arrAddress) {
    var objLatLng = new google.maps.LatLng(arrAddress['latittude'], arrAddress['longitude']);

    // Create marker
    var objMarker = new google.maps.Marker({
        position: objLatLng,
        map: objGoogleMaps,
        title: arrAddress['address'] + ' ' + arrAddress['zipcode'] + ' ' + arrAddress['city'],
    });
    // Make string with address data
    var strContentString = arrAddress['address'] + '<br\/>' + arrAddress['zipcode'] + ' ' + arrAddress['city'];

    // Show info window when clicked on marker
    var objInfowindow = new google.maps.InfoWindow({content: strContentString});
    google.maps.event.addListener(objMarker, 'click', function () {
        objInfowindow.open(objGoogleMaps, objMarker);
    });
}

window.CreateGoogleMaps = CreateGoogleMaps;
window.CreateGoogleMapsMarker = CreateGoogleMapsMarker;